/**
 * @author hxliu
 * @description 题库题目管理列表
 * @Date 2020/02/03
 */
import { component_tool } from '@/tool';
let { WizModal, WizButton } = component_tool;
import moment from "moment";
import React from "react";
import BankQuestionLook from '../bankQuestionLook';
import LlmSetting from "../llmSetting";
//配置项
let componentName = 'ReviewQuestion'

let ref;

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = (mode) => {
  let typeDict = [
    { code: 0, codeName: "单选题" },
    { code: 1, codeName: "多选题" },
    { code: 2, codeName: "判断题" },
    { code: 3, codeName: "填空题" },
    { code: 4, codeName: "主观题" },
  ]
  if (mode == 1) {
    typeDict = [
      { code: 0, codeName: "单选题" },
      { code: 1, codeName: "多选题" },
      { code: 2, codeName: "判断题" },
      { code: 3, codeName: "填空题" },
      { code: 5, codeName: "话术题" }
    ]
  }
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "题目类型",
      name: "type",
      dataIndex: "type",
      dict: typeDict,
      searchItem: {
        type: "select"
      },
    },

    {
      title: "难度",
      name: "difficulty",
      dataIndex: "difficulty",
      dict: [
        { code: 0, codeName: "低" },
        { code: 1, codeName: "中" },
        { code: 2, codeName: "高" }
      ],
      searchItem: {
        type: "select"
      }
    },

    {
      title: "题目内容",
      name: "title",
      dataIndex: "title",
      searchItem: {
      },
    },

    {
      title: "题目编码",
      name: "number",
      dataIndex: "number",
      searchItem: {
      }
    },
    {
      title: "题目类型",
      name: "type",
      dataIndex: "type",
      dict:typeDict,
      tableItem: {}
    },
    {
      title: "题目内容",
      name: "title",
      dataIndex: "title",
      tableItem: {
        width: 500,
      },
    },
    {
      title: "题目编码",
      name: "number",
      dataIndex: "number",
      tableItem: {
        width: 150,
      },
    },

    {
      title: "难度",
      name: "difficulty",
      dataIndex: "difficulty",
      dict: [
        { code: 0, codeName: "低" },
        { code: 1, codeName: "中" },
        { code: 2, codeName: "高" }
      ],
      tableItem: {},
    },
    {
      title: "创建时间",
      name: "createTime",
      dataIndex: "createTime",
      tableItem: {
        width: 200,
        render: (text) => {
          return formatterDate(text)
        }
      },
    },
    {
      title: "修改时间",
      name: "updateTime",
      dataIndex: "updateTime",
      tableItem: {
        width: 200,
        render: (text) => {
          return formatterDate(text)
        }
      },
    },
    window?.location?.hash?.includes('#/online/reviewQuestion') ? {} : {
      title: "关联考试数",
      name: "examCount",
      dataIndex: "examCount",
      tableItem: {
        width: 100,
      },
    },
  ]
}

const templateConfig = ({ mode }) => {
  let startPath = '/online/bankQuestion'
  if (mode == 1) {
    startPath = '/online/reviewQuestion'
  }
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(mode),
        searchBarProps: {
          buttonSort: ['add', 'delete', 'batchImport', 'export', 'llmSetting'],
          buttons: [
            {
              key: "add",
              custom: true,
              params: { children: "新增", icon: "plus", type: "primary" },
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: startPath+"/bankQuestionAdd",
                  record: {mode: mode}
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: {
                icon: "export", children: "导出", type: "export"
              },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'batchImport',
              custom: true,
              params: { icon: 'import', children: '批量导入', type: 'import' },
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: startPath+'/fileImport',
                  record: {mode: mode}
                }
              },
            },
            {
              key: "llmSetting",
              custom: true,
              params: { children: "模型参数" },
              customOnClick: {
                key: "modal",
                params: {
                  modalParams: {
                    title: "模型参数",
                    diy: (e) => {
                      const {changeModal, record} = e || {}
                      return <LlmSetting changeModal={changeModal} bizId={0}/>
                    },
                    width: 700,
                    footer: false,
                    destroyOnClose: true,
                  }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },

        rowOperateSort: ['look', 'update'],
        rowOperateView: [

          {
            key: "look",
            custom: true,
            params: { children: "查看" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  cancelButtonProps: { style: { height: 0, width: 0 } },
                  style: { minWidth: 700 },
                  //onOk: () => {ref._ok();},
                  //onCancel: () => {},
                  footer: null,
                  title: "题目查看",
                  diy: (e) => {
                    return (
                      <BankQuestionLook key={e.record.id}
                        //  record={record}
                        //key={new Date()}
                        {...e}
                        ref={r => {
                          ref = r && r.getWrappedInstance();
                        }}
                      />
                    )
                  },

                  onOk: () => { ref._onOk() },
                  width: 950
                }

              }
            }
          },
          {
            key: "update",
            custom: true,
            params: { children: "编辑" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: startPath+"/bankQuestionUpd",
                record: {mode: mode}
              }
            }
          },

        ]
      }
    }
  }
};

const apis = (mode) => {
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: { pageNum: 1, pageSize: 10, mode }
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: { mode }
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    },
  }
}


let reduxTemplateConfig = (args) => {
  let { mode } = args
  return {
    apis: apis(mode),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
